import { render, staticRenderFns } from "./moneyMovementDescription.vue?vue&type=template&id=4898fe4c&"
import script from "./moneyMovementDescription.vue?vue&type=script&lang=ts&"
export * from "./moneyMovementDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports